import { policyTypes } from '@ourbranch/policy-types';
import { fixableRejectionCodes } from '@ourbranch/lookups';

export default {
  Offer: {
    AbodeProPlan: 'AbodeProPlan',
    ConnectedHome: 'ConnectedHome',
    NewConnectedHomeSignUpCustomer: 'NewConnectedHomeSignUpCustomer',
    SelfReportedUWFlags: 'SelfReportedUWFlags',
    OfferNeedsUWReview: 'OfferNeedsUWReview',
    OfferWithOlderRoof: 'OfferWithOlderRoof',
    UnknownVerifiedAnnualMiles: 'UnknownVerifiedAnnualMiles',
    LapsedDriversLicenses: 'LapsedDriversLicenses',
    HomeRejection: 'HomeRejection',
    CannotPurchase: 'CannotPurchase',
    PotentialDriversIdentified: 'PotentialDriversIdentified',
    SkipUnderwritingActive: 'SkipUnderwritingActive'
  },
  Policy: {
    CrossSellEligibility: 'CrossSellEligibility',
    SignedConversionDocuments: 'SignedConversionDocuments',
    PendingThirdPartyPurchases: 'PendingThirdPartyPurchases',
    IncompleteTasks: 'IncompleteTasks',
    TransferToAgency: 'TransferToAgency',
    AgencyServicedByBranch: 'AgencyServicedByBranch'
  },
  Customer: {
    CrossSellEligibility: 'CrossSellEligibility',
    IncompleteTasks: 'IncompleteTasks',
    TransferToAgency: 'TransferToAgency',
    AgencyServicedByBranch: 'AgencyServicedByBranch'
  }
};

export function isPolicyCrossSellEligible({ offer, policyType, policyDetails }, isPolicyAgencySold, isAgencyUser) {
  const offerings = offer?.quote?.offerings;
  const offerAuto = offerings?.offerAuto;
  const autoRejectCode = offerings?.autoRejectCode;
  const homeownersRejectCode = offerings?.homeownersRejectCode;
  const offerHomeowners = offerings?.offerHomeowners;

  const canCrossSellHome =
    !policyDetails?.includeRenters &&
    offerHomeowners &&
    (!homeownersRejectCode || fixableRejectionCodes.includes(homeownersRejectCode));

  const canCrossSellAuto = offerAuto && (!autoRejectCode || fixableRejectionCodes.includes(autoRejectCode));

  const isCrossSellEligible = policyType === policyTypes.Home ? canCrossSellAuto : canCrossSellHome;

  // do not allow an internal user to cross sell an agency policy
  return isCrossSellEligible && (!isPolicyAgencySold || (isAgencyUser && isPolicyAgencySold));
}
